"use client";

import React from "react";
import { Mail, MapPin, Twitter, Send, Linkedin, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function FooterEssentials() {
  const currentYear = new Date().getFullYear();
  const ecosystemLinks = [{
    label: "Ecosystem",
    to: "/EcosystemPage"
  }, {
    label: "Tokenomics & Growth",
    to: "/TokenomicsAndGrowthPage"
  }, {
    label: "Team",
    to: "/PrivateRoundPage"
  }];
  const resourcesLinks = [{
    label: "Utility Token",
    to: "/AizaleaAIHealthcareUtilityTokenPage"
  }, {
    label: "Team & Ambassadors",
    to: "/TeamAndAmbassadorsPage"
  }, {
    label: "Whitepaper",
    to: "#"
  }, {
    label: "Documentation",
    to: "#"
  }];
  const socialLinks = [{
    icon: <Twitter className="size-5" />,
    label: "Twitter",
    to: "#"
  }, {
    icon: <Send className="size-5" />,
    label: "Telegram",
    to: "#"
  }, {
    icon: <Linkedin className="size-5" />,
    label: "LinkedIn",
    to: "#"
  }];
  return <footer data-section-id="35630" id="site-footer" className="bg-white border-t border-border py-4 lg:py-5 relative overflow-hidden font-sans">
      {}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-accent/30 -skew-x-12 translate-x-1/2 pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-3 mb-5">
          
          {}
          <div className="lg:col-span-4 flex flex-col space-y-3">
            <Link to="/AizaleaAIHealthcareUtilityTokenPage" className="inline-block">
              
            </Link>
            <p className="text-muted-foreground text-base leading-relaxed max-w-sm">
              The foundational utility token powering AizaHcare—a next-generation medical ecosystem integrating real-world infrastructure with AI-driven healthcare precision.
            </p>
            <div className="flex flex-col gap-2 text-sm text-foreground/80">
              <div className="flex items-center gap-3">
                <div className="size-6 rounded-full bg-accent flex items-center justify-center">
                  <MapPin className="size-3 text-primary" />
                </div>
                <span className="font-medium">Abu Dhabi, UAE</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="size-6 rounded-full bg-accent flex items-center justify-center">
                  <Mail className="size-3 text-primary" />
                </div>
                <span className="font-medium">contact@aizalea.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-1.5 ![margin:18px_0px_6px_50px] !p-0 lg:col-span-2">
            <h3 className="text-primary font-bold tracking-tight text-sm uppercase">NAVIGATION</h3>
            <nav className="flex flex-col space-y-2">
              {ecosystemLinks.map((link, i) => <Link key={link.label} data-index={i} to={link.to} className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit group flex items-center">
                  <span className="h-px w-0 bg-primary group-hover:w-3 transition-all duration-300 mr-0 group-hover:mr-2" />
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          
          

          {}
          <div className="lg:col-span-4 flex flex-col space-y-8">
            
            
          </div>
        </div>

        <Separator className="opacity-50 mb-5" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="flex flex-col gap-2">
            <p className="text-xs text-muted-foreground font-medium">
              © {currentYear} Aizalea. All rights reserved. Registered in UAE.
            </p>
            <p className="text-[10px] text-muted-foreground/60 max-w-2xl leading-relaxed italic">
              Disclaimer: Aizalea ($AIZA) is a utility token designed for ecosystem participation. Digital assets involve significant risk. This is not financial advice. 
            </p>
          </div>
          
          <div className="flex flex-wrap gap-6">
            <Link to="#" className="text-xs text-muted-foreground hover:text-primary transition-colors font-medium">
              Privacy Policy
            </Link>
            
            
          </div>
        </div>
      </div>
    </footer>;
}